import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";

const PriceRangeFilter = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    // State for price range
    const [priceRange, setPriceRange] = useState({
        minPrice: parseInt(searchParams.get('minPrice')) || 0,
        maxPrice: parseInt(searchParams.get('maxPrice')) || 150000,
    });

    // Debounce time
    const debounceTime = 500; // Adjust as needed
    const timeoutRef = useRef(null);

    // Effect to handle URL updates after debounce
    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            const currentMinPrice = parseInt(searchParams.get('minPrice')) || 0;
            const currentMaxPrice = parseInt(searchParams.get('maxPrice')) || 150000;

            if (priceRange.minPrice !== currentMinPrice || priceRange.maxPrice !== currentMaxPrice) {
                searchParams.set('minPrice', priceRange.minPrice);
                searchParams.set('maxPrice', priceRange.maxPrice);
                setSearchParams(searchParams);
            }
        }, debounceTime);

        return () => clearTimeout(timeoutRef.current);
    }, [priceRange, searchParams, setSearchParams]);

    const handlePriceChange = (e, isMin) => {
        const value = parseInt(e.target.value);
        setPriceRange((prev) => ({
            ...prev,
            [isMin ? 'minPrice' : 'maxPrice']: value,
        }));
    };

    return (
        <div className='category-container'>
            <h2 className='text-lg text-primary font-semibold'>Price Range :</h2>
            <hr/>
            <div className="d-flex">
                <div className="wrapper">
                    <div className="price-input">
                        <div className="field">
                            <span>Min: </span>
                            <input
                                type="number"
                                value={priceRange.minPrice}
                                min="0"
                                max={priceRange.maxPrice}
                            />
                        </div>
                        <div className="separator">-</div>
                        <div className="field">
                            <span>Max: </span>
                            <input
                                type="number"
                                value={priceRange.maxPrice}
                                min={priceRange.minPrice}
                                max="150000"
                            />
                        </div>
                    </div>
                    <div className="slider">
                        <div
                            className="progress"
                            style={{
                                left: `${(priceRange.minPrice / 150000) * 100}%`,
                                right: `${100 - (priceRange.maxPrice / 150000) * 100}%`,
                            }}
                        ></div>
                    </div>
                    <div className="range-input">
                        <input
                            type="range"
                            className="range-min"
                            min="0"
                            max="150000"
                            value={priceRange.minPrice}
                            step="1"
                            onChange={(e) => handlePriceChange(e, true)}
                        />
                        <input
                            type="range"
                            className="range-max"
                            min="0"
                            max="150000"
                            value={priceRange.maxPrice}
                            step="1"
                            onChange={(e) => handlePriceChange(e, false)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PriceRangeFilter;
